import {
  AtlasBodySubtitle,
  IconButtonMolecule
} from '@justomx/atlas-components'
import { StackAtom } from 'components/atoms/Stack.atom'
import { ListMolecule } from './List.molecule'

interface InstructionsMoleculeProps {
  lines: string[]
  ordered?: boolean
  iconName?: string
  onClickIcon?: () => void
}

export const InstructionsMolecule = (props: InstructionsMoleculeProps) => {
  const { lines, ordered = false, iconName, onClickIcon } = props

  return (
    <StackAtom $justify="space-between" $align="center">
      <StackAtom $gap={8} $direction="column">
        <AtlasBodySubtitle>Instrucciones</AtlasBodySubtitle>
        <ListMolecule lines={lines} ordered={ordered} />
      </StackAtom>

      {iconName && (
        <IconButtonMolecule
          type="button"
          secondary
          iconName={iconName}
          style={{ borderRadius: '100px', width: '40px', height: '40px' }}
          onClick={onClickIcon}
        />
      )}
    </StackAtom>
  )
}
